/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoggingService } from '../../../logging/logic/logging.service';
import { ConnectionType, NetworkService } from '../network.service';

import { Network } from '@capacitor/network';
import { EventService, IMSEventContentTypeHook, IMSEventMessageType, IMSEventSourceType, IMSInternalEventHook } from 'src/app/_services/event/event.service';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';

/**
 * Network Service checks for the current network situation
 */
@Injectable({
  providedIn: 'root',
})
export class NetworkLogicService implements NetworkService {
  // Public Member
  public connection$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public connectionType$: BehaviorSubject<ConnectionType> = new BehaviorSubject('none');
  

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private eventService: EventService,
    private appParameter: AppParameterService
  ) {
    Network.getStatus().then((status) => {
      this.connection$.next(status.connected);
      this.connectionType$.next(status.connectionType);
      if (status.connected) {
        const eventContent: IMSEventContentTypeHook = {
          kind: IMSEventMessageType.HOOK,
          hook: IMSInternalEventHook.INTERNETCONNECTIONCHANGE
        }
        this.eventService.sendEvent({
          source: {
            type: IMSEventSourceType.INTERNAL,
            contentType: eventContent
          }
        }, this.appParameter.appParameters$.getValue());
      }
    })
    Network.addListener('networkStatusChange', (status) => {
      this.logger.log(this.constructor.name, 'Network status changed', status);
      this.connection$.next(status.connected);
      this.connectionType$.next(status.connectionType);
    });
  }

  // Public Functions

  // Private Functions
}
